import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { NotificationListLayout, useNotificationsController } from '@atlassian/notification-common';
import { LoadingState } from '@atlassian/notification-common/types';
import { useFilteredNotifications, useIsMarkAllAsReadVisible, useNotificationCategoryFilters, useNotificationListFilterActions, useNotificationListStore, useNotificationProductFilters, useNotificationReadActions, useNotificationsLoadingState, useNotificationStateFilters } from '@atlassian/notification-store';
import NotificationList from './notification-list';
var ConnectedNotifications = function ConnectedNotifications(_ref) {
  var isGroupedNotificationsViewOn = _ref.isGroupedNotificationsViewOn,
    toggleGroupedNotificationsView = _ref.toggleGroupedNotificationsView,
    enableInbox = _ref.enableInbox,
    enableProductFiltering = _ref.enableProductFiltering;
  var intl = useIntl();
  var currentNotificationList = useNotificationListStore({
    locale: intl.locale
  });
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  useNotificationsController(currentNotificationList, filters);
  var _useFilteredNotificat = useFilteredNotifications(filters),
    _useFilteredNotificat2 = _slicedToArray(_useFilteredNotificat, 1),
    notifications = _useFilteredNotificat2[0];
  var _useNotificationsLoad = useNotificationsLoadingState(filters),
    _useNotificationsLoad2 = _slicedToArray(_useNotificationsLoad, 1),
    notificationState = _useNotificationsLoad2[0];
  var notificationFilters = useNotificationListFilterActions();
  var _useIsMarkAllAsReadVi = useIsMarkAllAsReadVisible(filters),
    _useIsMarkAllAsReadVi2 = _slicedToArray(_useIsMarkAllAsReadVi, 1),
    isMarkAllAsReadVisible = _useIsMarkAllAsReadVi2[0];
  var notificationReadActions = useNotificationReadActions();
  var _useNotificationCateg = useNotificationCategoryFilters(),
    _useNotificationCateg2 = _slicedToArray(_useNotificationCateg, 1),
    categoryFilters = _useNotificationCateg2[0];
  var _useNotificationProdu = useNotificationProductFilters(),
    _useNotificationProdu2 = _slicedToArray(_useNotificationProdu, 1),
    productFilters = _useNotificationProdu2[0];
  return /*#__PURE__*/React.createElement(NotificationListLayout, {
    fetchData: currentNotificationList.fetchData,
    listSize: notifications.length,
    fetchState: notificationState.fetchState,
    canLoadMore: notificationState.fetchState === LoadingState.COMPLETE && !!notificationState.continuationToken,
    notificationTabs: categoryFilters,
    productFilters: productFilters,
    notificationFilters: notificationFilters,
    NotificationListComponent: NotificationList,
    isMarkAllAsReadVisible: isMarkAllAsReadVisible,
    handleMarkAllNotificationsRead: notificationReadActions.handleMarkAllNotificationsRead,
    toggleGroupedNotificationsView: toggleGroupedNotificationsView,
    isGroupedNotificationsViewOn: isGroupedNotificationsViewOn,
    enableInboxAnnouncementBanner: enableInbox,
    enableProductFiltering: enableProductFiltering,
    fullPageNotificationBranding: enableInbox ? 'inbox' : 'full-page'
  });
};
export default ConnectedNotifications;